export default {
  boat: {
    header: 'Boat Insurance',
    body: `<div class="title-sm">Cast Your Worries Aside.</div>
<p>For most people, owning a boat can be a dream come true. Whether you’re out
on the water with friends or enjoying a relaxing day of fishing,
your boat provides an escape from the daily grind.</p>

<p>With a Boat Owners Insurance policy from SIG & Associates, you can relax and enjoy
your time away knowing that you’re properly insured. We offer many coverage options to
keep you, your boat, and its passengers safe, specializing in insurance for the following marine vehicles:</p>

<ul>
<li>Yachts</li>
<li>Performance Boats</li>
<li>Sail Boats</li>
<li>Bass Boats</li>
<li>Jet Skis</li>
<li>WaveRunners</li>
</ul>

<div class="title-sm">What Can a Boat Insurance Policy Cover?</div>
<p>Unfortunately, accidents happen – even on the water. A specialized Boat Insurance policy covers
your boat or personal watercraft, as well as its motor against potential loss due to:</p>

<ul>
<li>Vandalism</li>
<li>Collision with another boat or object</li>
<li>Theft</li>
<li>Damage caused by uninsured or under-insured boaters</li>
</ul>

<p>Your policy also extends to protect extra equipment attached to your boat such as anchors,
oars, canopies, life preservers, and fuel tanks. Coverage for fishing equipment and
personal property is also available.</p>

<p>In addition, Liability Boat Insurance can help pay for medical expenses or legal
costs if you’re at fault in a boating accident. Coverage options include:</p>

<ul>
<li>Bodily Injury payments</li>
<li>Damage to another’s property</li>
<li>Medical Payments</li>
<li>Guest Passenger Liability</li>
</ul>

<div class="title-sm">Additional Coverage Options</div>
<p>At SIG & Associates, we make insuring your boat or personal watercraft easy and affordable by offering
extended policy benefits like On-Water Towing and Roadside Assistance when traveling with your boat.
You may also be eligible for money-saving discounts when you insure multiple watercrafts or combine your
Boat and Auto policies. Even simple things like being an accident-free boater and
completing a boating safety course can help you save money too.</p>

<p>It’s your passion, your dream. Protect that dream for years to come with the right insurance
policy from SIG & Associates. Talk with one of our local insurance
specialists today to learn more about Boat Owners Insurance.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  motorcycle: {
    header: 'Motorcycle Insurance',
    body: `<div class="title-sm">Protection for the Open Road</div>

<p>Whether you ride a street bike, cruiser, touring bike, or even a custom chopper,
your motorcycle is synonymous with two things: freedom and adventure.
You enjoy the freedom and excitement of the open road and long for the adventure it brings,
but with adventure comes uncertainty, and with freedom comes responsibility.
And while you may not know what lies over the next hill, the right coverage can ensure that you're prepared for it all.</p>

<p>A Motorcycle Insurance policy from SIG & Associates is designed to be as
unique as the bike and the owner it protects. Make sure you choose the
protection that’s right for you with a range of coverage options to secure you and your bike, such as:</p>

<ul>
<li>Collision Coverage</li>
<li>Theft</li>
<li>Vandalism</li>
<li>Damage caused by Uninsured or Under-insured Motorists</li>
<li>Bodily Injury Liability</li>
<li>Property Damage Liability</li>
<li>Medical Payments Coverage</li>
<li>Guest Passenger Liability</li>
</ul>

<div class="title-sm">Additional Motorcycle Coverage Options</div>

<p>At SIG & Associates, our service doesn’t stop when you walk out the door.
With special features like additional Roadside Assistance, Towing and Labor Costs,
and Replacement coverage for custom parts and equipment, you’ll never be alone on the road.
You can even receive multi-policy discounts and safety course rewards to help you combine and save.</p>

<p>Our team of professional insurance representatives will assist you in deciding which
Motorcycle Insurance plan is right for you by determining the discounts
and special features you may be eligible to receive.</p>

<p>Prepare for whatever the open road may bring with a
comprehensive Motorcycle Insurance policy from SIG & Associates.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  motorhome: {
    header: 'Motor-Home Insurance',
    body: `<div class="title-sm">It’s More Than a Vehicle. It’s a Lifestyle.</div>

<p>As a motorhome owner, you get the best of both worlds by combining the
freedom of the open road with all of the conveniences and amenities you enjoy at home.
And just like your home, your recreational vehicle is a big investment that should be protected.</p>

<p>Motorhome Insurance from SIG & Associates is a convenient and affordable
way to ensure the safety of you, your passengers, and your belongings on the road.</p>

<p>Your motorhome policy from SIG & Associates is designed to provide the
rates you want with the coverage you need, with basic protection options such as:</p>

<ul>
<li><b>Collision Coverage</b> – for loss or damage to your recreational vehicle resulting from an accident</li>
<li><b>Comprehensive Coverage</b> – as extra coverage against losses from fire, theft, or vandalism</li>
<li><b>Bodily Injury Liability</b> – to pay medical expenses to others after an accident</li>
<li><b>Property Damage Liability</b> – for damage caused by you to another person’s property</li>
</ul>

<div class="title-sm">Extra Protection Matters</div>

<p>For an increased level of security, additional insurance options such as
Medical Payments coverage, Emergency Roadside Assistance, and Premium Towing and
Labor are also available. Custom equipment such as quality sound or
entertainment systems can also be covered for an extra premium.</p>

<p>SIG & Associates wants to ensure that you receive the best insurance
solutions at the best price possible. You may be eligible to start saving today with discounts for:</p>

<ul>
<li>Association memberships</li>
<li>Completion of a driver safety course</li>
<li>Insuring multiple vehicles</li>
<li>Combining your Motorhome Insurance with other policies from SIG & Associates </li>
</ul>

<p>Our team of RV Insurance specialists is ready to discuss your
insurance needs and your budget to help design the right policy
that keeps you and your motorhome, or travel trailer, safe on the road.</p>

<p>Wherever your journeys may take you, rest easy with the
peace of mind of Motorhome Insurance from SIG & Associates.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  atv: {
    header: 'ATV Insurance',
    body: `<div class="title-sm">Explore the Trails With Confidence</div>
<p>Your ATV represents a considerable recreation investment.
And as you’re riding, the last thing you’ll want to wonder about is whether you have the right insurance coverage.
With a customized All-Terrain Vehicle insurance policy from SIG & Associates,
you can ride with confidence knowing that you’re properly insured.</p>

<p>No matter what type of vehicle you have, whether you ride a 4-wheeler, dune buggy,
or even a golf cart, you can get the ATV Insurance you want and the protection
you deserve with specialized coverage options, including:</p>

<ul>
<li><b>Collision Coverage</b> – for damage to your ATV from rocks, trees, and other obstacles or debris</li>
<li><b>Comprehensive Coverage</b> – as extra security for loss or damage from theft, fire, or vandalism</li>
<li><b>Property Damage</b> – to cover expenses to another person’s property for which you are liable</li>
<li><b>Bodily Injury</b> – that pays medical expenses to others if you’re held liable in an accident</li>
<li><b>Uninsured Motorist</b> – to protect you from loss or damage caused by uninsured and under-insured riders</li>
</ul>

<p>SIG & Associates is dedicated to offering you the best possible
coverage at a price you can afford. We offer additional ATV coverage for damage to custom equipment
that you’ve added to your ATV, along with a medical payments option for yourself and your passengers.
You may also be eligible for money-saving discounts when you insure multiple vehicles
or if you’ve successfully completed a rider safety course.</p>

<p>Discounts and coverage options can vary according to your location and specifications.
Contact one of our licensed insurance professionals to learn more about
ATV insurance and how to build a recreational plan that best fits your needs.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  snowmobile: {
    header: 'Snowmobile Insurance',
    body: `<div class="title-sm">When the Snow Falls, Make Sure You’re Ready</div>
<p>Nothing is quite as satisfying as hitting the trails after the first snow.
Your snowmobile is your ticket to enjoying the fresh mountain air and exhilarating scenery of the countryside,
and while you’re out there in the thick of it all, contemplating whether you have
the right insurance should be the last thing on your mind.</p>

<p>SIG & Associates offers specialized Snowmobile Insurance at affordable rates,
with benefits tailored to meet your specific insurance needs.
Whether you’re a beginner or a seasoned veteran, we offer essential coverage for:</p>

<ul>
<li><b>Collision Coverage</b> – to cover damage to your snowmobile from a collision with rocks, trees, ice, and other obstacles</li>
<li><b>Comprehensive Coverage</b> – as extended coverage for loss or damage from theft, fire, or vandalism</li>
<li><b>Property Damage</b> – to pay for damage to another person’s property for which you are liable</li>
<li><b>Bodily Injury Liability</b> – that pays medical expenses to others if you’re held liable in an accident</li>
<li><b>Uninsured Motorist Protection</b> – to insure damage caused by uninsured or under-insured riders</li>
</ul>

<p>Additional Snowmobile Insurance coverage is also available for any custom equipment that
you’ve added to your snowmobile. Medical Payments Coverage to protect yourself and
your passengers in the event of an accident is also available for a premium.</p>

<p>Depending on your insurance situation, discounts may also be available for completing rider
safety courses or by being a member of certain riding association memberships.
A representative from SIG & Associates will review your insurance needs to design
the right policy for you and determine your discount eligibility.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/rvHelper.js